import React, { useRef, useState, useEffect } from "react";
import { Button, Input, Modal, Select } from "antd";
import { deletedCode } from "../../lib/util/codeUtil";
import SelectBox from "../common/SelectBox";
import { httpUrl, httpPost, httpGet } from "../../api/httpClient";
import styled from 'styled-components';


const { Option } = Select;

const UserDialog = (props) => {
    const close = props.close;
    const data = props.data;
    const edit = props.edit;
    const idx = data ? props.data.idx : null;

    const [inputs, setInputs] = useState({
        // id: data ? data.id : "",
        password: "",
        name: data ? data.name : "",
        tel: data ? data.tel : "",
    })
    const FrequencyEmails = [
        '@naver.com',
        '@gmail.com',
        '@daum.net',
        '@hanmail.net',
        '@yahoo.com',
        '@nate.com',
        '@kakao.com',
    ];
    const [id, setId] = useState(data ? data.id : "");
    const [emailList, setEmailList] = useState(FrequencyEmails);
    const [selected, setSelected] = useState(-1);
    const [isDropBox, setIsDropbox] = useState(false);
    const inputRef = useRef();


    const formRef = useRef(null);

    const { password, name, tel } = inputs;

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                inputRef.current &&
                !inputRef.current.contains(e.target)
            ) {
                setIsDropbox(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
    }, [inputRef]);

    const onChangeEmail = (e) => {
        setId(e.target.value);
        if (e.target.value.includes('@')) {
            setIsDropbox(true);
            setEmailList(
                FrequencyEmails.filter((el) =>
                    el.includes(e.target.value.split('@')[1]),
                ),
            );
        } else {
            setIsDropbox(false);
            setSelected(-1);
        }
    };

    const handleDropDownClick = (first, second) => {
        setId(`${first.split('@')[0]}${second}`);
        setIsDropbox(false);
        setSelected(-1);
    };

    const handleKeyUp = (e) => {
        if (isDropBox) {
            if (e.key === 'ArrowDown' && emailList.length - 1 > selected) {
                setSelected(selected + 1);
            }
            //emailList.length에 -1을 해주는 이유는 selected의 최대값을 맞춰주기 위해서이다.
            //예를들어 밑에 emailList 2개가 나왔다고 가정했을 때, selected값이 최대 1까지 변할 수 있게 해줘야한다. 
            //'ArrowDown'키를 누르면 selected는 0이 되고, 한번 더 누르면 1이 되고, 그 다음은 더이상 옵션이 없기 때문에 키가 안먹히게 해주는 것이다.

            if (e.key === 'ArrowUp' && selected >= 0) {
                setSelected(selected - 1);
            }
            if (e.key === 'Enter' && selected >= 0) {
                handleDropDownClick(id, emailList[selected]);
            }
        }
    };
    const MailTipLi =
        styled.li`
    background-color: ${({ selected }) => (selected ? '#f5f5f5' : '')};
    color: ${({ selected }) => (selected ? 'var(--zu--m4-color)' : '')};
  `;

    const onChange = (e) => {
        const { value, name } = e.target;
        if (e.target.name === 'tel') {
            let number = e.target.value.replace(/[^0-9]/g, "");
            setInputs({
                ...inputs,
                tel: number
            })
        } else if (e.target.name === 'id') {
            setId({
                ...inputs,
                [name]: value
            })
        }
        else {
            setInputs({
                ...inputs,
                [name]: value
            });
        }

    }

    const onCreateUser = () => {
        const regExp = new RegExp(/^[!$^()-_0-9a-zA-Z!$^()-_]([-_.]?[!$^()-_0-9a-zA-Z!$^()-_])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*/i);
        if (id === null || id === "") {
            alert("이메일 입력은 필수사항입니다. 다시 확인해주세요.")
            return;
        }
        if (!id.match(regExp)) {
            alert('이메일 형식을 다시 확인해주세요.')
            return;
          }
        if (password === null || password === "") {
            alert("비밀번호 입력은 필수사항입니다. 다시 확인해주세요.")
            return;
        }
        if (name === null || name === "") {
            alert("이름 입력은 필수사항입니다. 다시 확인해주세요.")
            return;
        }
        Modal.confirm({
            title: "사용자를 등록합니다.",
            content: "사용자의 정보를 등록하시겠습니까?",
            okText: "확인",
            cancelText: " 취소",
            onOk() {
                httpPost(httpUrl.userCreate, [], {
                    id, name, tel, userType: 1, password
                }).then((res) => {
                    if (res.data === "SUCCESS") {
                        Modal.info({
                            title: "등록 완료",
                            content: "사용자의 정보를 등록했습니다."
                        })
                        props.close();
                    } else if (res.data === "DUPLICATE") {
                        Modal.error({
                            title: "등록 오류",
                            content: "이미 존재하는 이메일입니다."
                        });
                    } else if (res.data === "USER_DUPLICATED") {
                        Modal.error({
                            title: "등록 오류",
                            content: "존재하는 사용자 정보입니다."
                        });
                    } else {
                        Modal.error({
                            title: "등록 오류",
                            content: "오류가 발생했습니다. 관리자에게 문의해주세요."
                        });
                    }
                })
            }
        })
    }

    const onModifyUser = (e) => {

        if (id === null || id === "") {
            alert("이메일 입력은 필수사항입니다. 다시 확인해주세요.")
            return;
        }
        if (name === null || name === "") {
            alert("이름 입력은 필수사항입니다. 다시 확인해주세요.")
            return;
        }
        if (name === data.name && tel === data.tel && password === "") {
            alert("변경사항이 없습니다. 다시 확인해주세요.")
            return;
        }

        Modal.confirm({
            title: "사용자의 정보를 수정합니다.",
            content: "사용자의 정보를 수정하시겠습니까?",
            okText: "확인",
            cancelText: " 취소",
            onOk() {
                httpPost(httpUrl.userUpdate, [], {
                    idx, name, tel, password
                }).then((res) => {
                    if (res.data === true) {
                        Modal.info({
                            title: "수정 완료",
                            content: "사용자의 정보를 수정했습니다."
                        })
                        props.close();
                    } else {
                        Modal.error({
                            title: "수정 오류",
                            content: "오류가 발생했습니다. 관리자에게 문의해주세요."
                        });
                    }
                })
            }
        })
        e.stopPropagation();
    }

    return (

        <div>
            <div className="modal-overlay" onClick={close} />
            <div className="modal-wrapper">
                <div className="modal-header">
                    <div>
                        <span style={{ fontWeight: '600' }}>{data && data.id}</span> {!data ? "등록" : "수정"}
                    </div>
                    <Button onClick={close} style={{ border: 'none', boxShadow: 'none' }}>
                        close
                    </Button>
                </div>

                {!data ?
                    <div className="modal-contents">
                        <div>
                            <p> <span style={{ color: '#cc0000' }}>*</span>이메일 </p>
                            <Input
                                name="id"
                                className="memo-input"
                                placeholder="이메일을 입력해주세요"
                                // onChange={onChange}
                                ref={formRef}
                                value={id}
                                onChange={(e) => {
                                    onChangeEmail(e);
                                }}
                                onKeyUp={handleKeyUp}
                            />
                        </div>
                        {isDropBox && (
                            <div className="emailList">
                                {emailList.map((item, idx) => (
                                    <MailTipLi
                                        className="emailList2"
                                        key={idx}
                                        onMouseOver={() => setSelected(idx)}
                                        onClick={() => handleDropDownClick(id, item)}
                                        selected={selected === idx}
                                    >
                                        {id.split('@')[0]}
                                        {item}
                                    </MailTipLi>
                                ))}
                            </div>
                        )}
                        <div>
                            <p> <span style={{ color: '#cc0000' }}>*</span>비밀번호 </p>
                            <Input
                                name="password"
                                className="memo-input"
                                placeholder="비밀번호 입력해주세요"
                                onChange={onChange}
                                ref={formRef}
                                type="password"
                            />
                        </div>
                        <div>
                            <p> <span style={{ color: '#cc0000' }}>*</span>이름 </p>
                            <Input
                                name="name"
                                className="memo-input"
                                placeholder="이름을 입력해주세요"
                                onChange={onChange}
                                ref={formRef}
                            />
                        </div>
                        <div>
                            {/* <p> <span style={{ color: '#cc0000' }}>*</span>연락처 </p> */}
                            <p> 연락처 </p>
                            <Input
                                name="tel"
                                className="memo-input"
                                placeholder="핸드폰 번호를 입력해주세요"
                                onChange={onChange}
                                value={tel}
                                ref={formRef}
                                type="tel"
                                maxLength={11}
                            />
                        </div>
                        <div className="btn-wrapper">
                            <Button onClick={onCreateUser}>저장하기</Button>
                        </div>
                    </div>
                    :

                    <div className="modal-contents">
                        <div>
                            <p> <span style={{ color: '#cc0000' }}>*</span>이메일 </p>
                            <Input
                                name="id"
                                className="memo-input"
                                placeholder="이메일을 입력해주세요"
                                defaultValue={data.id}
                                onChange={onChange}
                                value={id}
                                ref={formRef}
                                disabled={true}
                            />
                        </div>
                        <div>
                            <p> <span style={{ color: '#cc0000' }}>*</span>비밀번호 </p>
                            <Input
                                name="password"
                                className="memo-input"
                                placeholder="비밀번호를 입력해주세요"
                                defaultValue={data.password}
                                onChange={onChange}
                                value={password}
                                ref={formRef}
                            />
                        </div>
                        <div>
                            <p> <span style={{ color: '#cc0000' }}>*</span>이름 </p>
                            <Input
                                name="name"
                                className="memo-input"
                                placeholder="이름을 입력해주세요"
                                defaultValue={data.name}
                                onChange={onChange}
                                value={name}
                                ref={formRef}
                            />
                        </div>
                        <div>
                            {/* <p> <span style={{ color: '#cc0000' }}>*</span>연락처 </p> */}
                            <p> 연락처 </p>
                            <Input
                                name="tel"
                                className="memo-input"
                                placeholder="핸드폰 번호를 입력해주세요"
                                defaultValue={data ? data.tel : ""}
                                onChange={onChange}
                                value={tel}
                                ref={formRef}
                                type="tel"
                                maxLength={11}
                            />
                        </div>
                        <div className="btn-wrapper">
                            <Button onClick={(e) => { onModifyUser(e) }}>저장하기</Button>
                        </div>
                    </div>


                }

            </div>
        </div>
    )

}
export default UserDialog;